import AbsenceAcceptContent from './absence-accept-content'

export default AbsenceAcceptContent
